import { Component } from '@angular/core';
import { UserService } from 'bookraw/shared/services/user.service';

@Component({
  selector: 'app-logout',
  template: `<mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>`
})
export class LogoutComponent {

  constructor(private userService: UserService) {
    userService.logout().subscribe(() => console.log('Logged out'), error => console.log(error));
  }
}
